module.exports = __webpack_public_path__ + "img/mobile.00905f84.svg";